<template>
  <div class="operation-options_item"
       @click="$emit('click')">
    <component :is="`icon-${option}`"
               class="text-icon transition duration-200"
               :class="active && 'text-icon-hover'"/>
  </div>
</template>

<script>
import IconAgent from "@/components/icons/operationIcons/IconAgent";
import IconTags from "@/components/icons/operationIcons/IconTags";
import IconComment from "@/components/icons/operationIcons/IconComment";
import IconCategory from "@/components/icons/operationIcons/IconCategory";
import IconCalendar from "@/components/icons/IconCalendar";

export default {
  name: "TransactionOptionsItem",
  components: {IconCalendar, IconComment, IconTags, IconAgent, IconCategory},
  props: {
    option: {
      type: String,
      required: true
    },
    active: {
      type: Boolean,
      required: true
    }
  }
}
</script>

<style lang="scss">
.operation-options_item {
  @apply flex items-center justify-center w-10 h-10 rounded cursor-pointer transition duration-200 border border-border;

  &:hover {
    @apply border-icon-hover;
  }
}
</style>